import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { getIconStyles as o } from "../styles.js";
const t = (e) => /* @__PURE__ */ l(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o(e),
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9993 5.25087C16.3437 5.18354 20.6984 8.18397 23.3782 11.1303L23.3806 11.133C23.7798 11.5762 24.0007 12.1515 24.0007 12.748C24.0007 13.3444 23.7798 13.9197 23.3806 14.3629L23.3784 14.3653C20.7596 17.2474 16.4156 20.3164 11.9993 20.2481C7.58304 20.3164 3.23997 17.2474 0.623064 14.3651L0.621072 14.3629C0.22188 13.9197 0.000976562 13.3444 0.000976562 12.748C0.000976562 12.1515 0.221885 11.5762 0.621076 11.133L0.623214 11.1306C3.30026 8.18394 7.65497 5.18354 11.9993 5.25087ZM1.73469 12.1379C1.58423 12.3055 1.50098 12.5227 1.50098 12.748C1.50098 12.9732 1.58424 13.1905 1.73474 13.3581C4.2434 16.1206 8.20793 18.8117 11.9867 18.7481H12.012C15.7908 18.8117 19.7563 16.1206 22.267 13.3579C22.4175 13.1904 22.5007 12.9732 22.5007 12.748C22.5007 12.5228 22.4175 12.3056 22.2671 12.138C19.7014 9.31784 15.7247 6.68823 12.012 6.75086H11.9867C8.27385 6.68823 4.29709 9.318 1.73469 12.1379Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.1478 9.97717C12.7838 9.82641 12.3936 9.74886 11.9995 9.74897C11.4062 9.74897 10.826 9.92489 10.3327 10.2545C9.83938 10.5841 9.45486 11.0526 9.22778 11.6007C9.00069 12.1489 8.94123 12.752 9.05692 13.3339C9.17262 13.9159 9.45826 14.4504 9.87774 14.87C10.2972 15.2896 10.8317 15.5754 11.4136 15.6912C11.9955 15.8071 12.5986 15.7478 13.1468 15.5208C13.695 15.2939 14.1636 14.9095 14.4934 14.4163C14.8231 13.923 14.9992 13.3431 14.9993 12.7498C14.9995 12.3557 14.9221 11.9653 14.7714 11.6012C14.6208 11.2371 14.3998 10.9063 14.1212 10.6276C13.8426 10.349 13.5119 10.1279 13.1478 9.97717ZM11.9993 8.24897C12.5904 8.24883 13.1757 8.36517 13.7218 8.59132C14.2679 8.81749 14.7641 9.14908 15.182 9.56712C15.6 9.98516 15.9314 10.4815 16.1574 11.0277C16.3835 11.5738 16.4996 12.1591 16.4993 12.7502M11.9993 8.24897C11.1094 8.24901 10.2393 8.51289 9.4994 9.00727C8.7594 9.50168 8.18262 10.2044 7.842 11.0266C7.50137 11.8488 7.41218 12.7536 7.58572 13.6264C7.75925 14.4993 8.18772 15.3011 8.81693 15.9305C9.44615 16.5599 10.2479 16.9886 11.1207 17.1624C11.9935 17.3361 12.8983 17.2472 13.7206 16.9068C14.5429 16.5664 15.2458 15.9898 15.7404 15.2499C16.2349 14.5101 16.4991 13.6401 16.4993 12.7502",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  t as EyeOnIcon
};
//# sourceMappingURL=EyeOnIcon.js.map
